
import { Injectable } from '@angular/core';
import {
    CanActivate, Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    CanActivateChild,
    CanLoad, Route, CanMatch, UrlTree, UrlSegment
} from '@angular/router';
import { AuthGuard } from './auth.guard';
import {AuthGuard as AuthGuardAuth0} from '@auth0/auth0-angular';
import { AuthService as AuthServiceSSO } from "@auth0/auth0-angular";
import { Observable } from 'rxjs';
import {AuthService} from "../../../services/auth.service";

@Injectable()
export class MasterGuard implements CanActivate, CanActivateChild, CanLoad, CanMatch {

    constructor(
        private authGuard: AuthGuard,
        private authGuardAuth0: AuthGuardAuth0,
        private auth0Service: AuthServiceSSO,
        private authService: AuthService,
        private router: Router
    ) {}

    private useAuth0Guard(): boolean {
        const isSSO =  localStorage.getItem('isSSOFlow');
        return isSSO === 'true';
    }

    private checkSsoInUrl(route: ActivatedRouteSnapshot): boolean {
        const ssoSegment = route.url.find(segment => segment.path === 'sso');
        return !!ssoSegment;
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        // if the URL contains /sso, start the SSO flow
        if (this.checkSsoInUrl(route)) {
            localStorage.setItem('isSSOFlow', 'true');
            this.auth0Service.loginWithRedirect().subscribe(() => {
                this.router.navigate(['/']);
            });
        }

        if (this.useAuth0Guard()) {
            this.auth0Service.error$.subscribe((err) => {
                if (err.message !== 'RETRY-LOGIN-PROCESS') {
                    localStorage.setItem('isSSOFlow', 'false');
                    this.authService.clearSessionData();
                    this.router.navigate(['/login']);
                    return false;
                }
            })
            return this.authGuardAuth0.canActivate(route, state);
        } else {
            return this.authGuard.canActivate(route, state);
        }
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        if (this.useAuth0Guard()) {
            return this.authGuardAuth0.canActivateChild(route, state);
        } else {
            return this.authGuard.canActivateChild(route, state);
        }
    }

    canLoad(route: Route, segments: UrlSegment[]): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        if (this.useAuth0Guard()) {
            return this.authGuardAuth0.canLoad(route, segments);
        } else {
            return this.authGuard.canLoad(route);
        }
    }

    canMatch(route: Route): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        return this.authGuard.canMatch(route);
    }
}
